const configObject = {
  guestJWT: /* expires on 18 June 2029 */
	"eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAyOS0wNi0xNVQxMjoyNzowOC4yMTAwMzIrMDI6MDAifQ.BQI6A3cTrCQcSzuhl0nzL948SpjC_h8tCeoPOrINWUY",
  expiredGuestJWTs: [
    "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAxOS0wNS0yOVQxNDo1MTo0OC4yOTUxNDFaIn0.1vGh3vFfZPgAhxiR7kEl39UZzjSCq92-z_4owHJyJsg",
    "eyJhbGciOiJIUzI1NiJ9.eyJ1c2VybmFtZSI6Imd1ZXN0IiwiZXhwaXJ5IjoiMjAyMC0wNi0xMFQxMzo1OTozMS4yNjQ4NDArMDI6MDAifQ.nqy-ZIkGRLI1x-TX782u3DFZpwP9fIK8TjwXBDzBBk8"
  ]
}

export default configObject



// WEBPACK FOOTER //
// ./src/variables.js